/**
 * 全員共通の支払条件(2026-10-23 段階2・settings/payment_terms)。全体設計 4章:
 * ドライバー報酬は全員共通の設定を1つ持ち、必要な人だけ個別に上書きする(個別の上書きは外部連携の段階で付ける)。
 * 読み書きは settings(読む: 社内の全員 / 書く: 管理者)。未設定なら null(期日は計上日のまま)
 */
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getDb } from '@core/lib/firebase';
import type { PaymentTerms } from '@core/lib/types';
import { validateTerms } from './terms';

export type PaymentTermsSettings = {
  /** ドライバー報酬(Routine の③)の支払条件 */
  driver_pay: PaymentTerms | null;
};

export async function fetchPaymentTermsSettings(): Promise<PaymentTermsSettings> {
  const snap = await getDoc(doc(getDb(), 'settings', 'payment_terms'));
  const data = snap.data() as Partial<PaymentTermsSettings> | undefined;
  return { driver_pay: data?.driver_pay ?? null };
}

export async function savePaymentTermsSettings(s: PaymentTermsSettings): Promise<void> {
  if (s.driver_pay) {
    const invalid = validateTerms(s.driver_pay);
    if (invalid) throw new Error(`ドライバー報酬の支払条件: ${invalid}`);
  }
  await setDoc(doc(getDb(), 'settings', 'payment_terms'), s, { merge: true });
}
